import { Flow_0_0_2 } from '@flexus/core';

export const BET_102: Flow_0_0_2 = {
	id: '102',
	name: 'assessor_claim_done',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
